const Footer = ({ navigateTo }) => {
  return (
    <footer className="w-full py-8 px-6 mt-auto" style={{ background: "var(--zen-bg)", borderTop: "1px solid var(--zen-border)" }}>
      <div className="max-w-4xl mx-auto">
        {/* Links row */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 mb-4">
          <button onClick={() => navigateTo("terms")} className="text-xs hover:opacity-70 transition-opacity" style={{ color: "var(--zen-sub)" }}>
            Terms of Service
          </button>
          <button onClick={() => navigateTo("privacy")} className="text-xs hover:opacity-70 transition-opacity" style={{ color: "var(--zen-sub)" }}>
            Privacy Policy
          </button>
          <button onClick={() => navigateTo("refund-policy")} className="text-xs hover:opacity-70 transition-opacity" style={{ color: "var(--zen-sub)" }}>
            Refund Policy
          </button>
          <a href="mailto:support@japanunfolded.ai" className="text-xs hover:opacity-70 transition-opacity" style={{ color: "var(--zen-sub)" }}>
            support@japanunfolded.ai
          </a>
        </div>

        {/* Payment icons + copyright */}
        <div className="flex flex-col items-center gap-3">
          <div className="flex items-center gap-3">
            {/* Visa */}
            <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Visa">
              <rect x="0.5" y="0.5" width="37" height="23" rx="3.5" fill="#fff" stroke="#E5E5E0"/>
              <path d="M15.74 15.74h-2.1l1.31-8.1h2.1l-1.31 8.1zm8.83-7.9a5.2 5.2 0 00-1.88-.34c-2.07 0-3.53 1.1-3.54 2.68-.01 1.17 1.04 1.82 1.84 2.21.81.4 1.09.65 1.08 1.01-.01.54-.65.79-1.24.79-.83 0-1.27-.12-1.95-.42l-.27-.13-.29 1.8c.48.22 1.38.42 2.31.43 2.2 0 3.63-1.09 3.64-2.77.01-.92-.55-1.63-1.76-2.21-.73-.37-1.18-.63-1.18-.99.01-.35.38-.7 1.2-.7.69-.01 1.18.15 1.57.31l.19.09.28-1.76zm5.42-.2h-1.62c-.5 0-.88.14-1.1.67l-3.12 7.43h2.2s.36-.99.44-1.22h2.69c.06.28.26 1.22.26 1.22h1.95l-1.7-8.1zm-2.58 5.23c.17-.47.84-2.27.84-2.27-.01.02.17-.47.28-.77l.14.7s.4 1.96.49 2.34h-1.75zM13.42 7.64l-2.05 5.52-.22-1.12c-.38-1.29-1.56-2.68-2.88-3.38l1.88 7.07h2.22l3.27-8.1h-2.22z" fill="#1A1F71"/>
              <path d="M9.2 7.64H5.87l-.03.18c2.63.67 4.37 2.3 5.09 4.25l-.73-3.73c-.13-.51-.5-.67-.99-.7z" fill="#F9A533"/>
            </svg>

            {/* Mastercard */}
            <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Mastercard">
              <rect x="0.5" y="0.5" width="37" height="23" rx="3.5" fill="#fff" stroke="#E5E5E0"/>
              <circle cx="15" cy="12" r="7" fill="#EB001B"/>
              <circle cx="23" cy="12" r="7" fill="#F79E1B"/>
              <path d="M19 6.8a7 7 0 012.6 5.2A7 7 0 0119 17.2 7 7 0 0116.4 12 7 7 0 0119 6.8z" fill="#FF5F00"/>
            </svg>

            {/* Amex */}
            <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="American Express">
              <rect x="0.5" y="0.5" width="37" height="23" rx="3.5" fill="#016FD0" stroke="#E5E5E0"/>
              <text x="19" y="13.5" textAnchor="middle" fill="#fff" fontSize="7" fontFamily="Helvetica, Arial, sans-serif" fontWeight="bold">AMEX</text>
            </svg>
          </div>

          <p className="text-[11px]" style={{ color: "var(--zen-dim)" }}>
            &copy; 2026 JapanUnfolded. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
